module.exports = __webpack_public_path__ + "static/media/seven.2638b0f2.png";